import { render, staticRenderFns } from "./VaccineReceipt.vue?vue&type=template&id=697172ac&scoped=true"
import script from "./VaccineReceipt.vue?vue&type=script&lang=js"
export * from "./VaccineReceipt.vue?vue&type=script&lang=js"
import style0 from "./VaccineReceipt.vue?vue&type=style&index=0&id=697172ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697172ac",
  null
  
)

export default component.exports